<template>
  <div>
    <v-text-field v-model="form.name"
                  label="Disclaimer name"
                  placeholder="Required"
                  outlined
                  required
                  :error-messages="form.errors.get('name')">
    </v-text-field>

    <v-text-field v-model="form.title"
                  label="Title"
                  placeholder="Optional"
                  outlined
                  :error-messages="form.errors.get('title')">
    </v-text-field>

    <v-textarea v-model="form.content"
                label="Content"
                placeholder="Required"
                outlined
                rows="2"
                required
                :error-messages="form.errors.get('content')">
    </v-textarea>

    <v-autocomplete v-model="form.presentations"
                    label="Presentations using this disclaimer"
                    outlined
                    :items="presentations"
                    item-value="id"
                    item-text="name"
                    multiple
                    chips
                    deletable-chips
                    small-chips
                    clearable>
    </v-autocomplete>

    <v-radio-group v-model="form.status"
                   label="Status"
                   class="mt-0">
      <v-radio value="Active"
               label="Active">
      </v-radio>
      <v-radio value="Inactive"
               label="Inactive">
      </v-radio>
    </v-radio-group>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    disclaimer: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters([
      'presentations',
    ])
  }
}
</script>
